import { LANGUAGE_CODE_OPTIONS } from './list';

export interface GuaranteeDocument {
	id: number;
	sequence: number;
	files: GuaranteeDocumentFile[];
}

export type FieldOfGuaranteeDocument = keyof GuaranteeDocument;

export const GUARANTEE_DOCUMENT_FIELD: FieldOfGuaranteeDocument[] =
	['id', 'files', 'sequence'];

export interface GuaranteeDocumentFile {
	id: number;
	title: string;
	fileName: string;
	path: string;
	lang: keyof typeof LANGUAGE_CODE_OPTIONS;
	type: string;
}
